import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

import bookImg from "@/assets/images/promotion/credentials-carousel/handbok-bolagsstyrning.png";

const BOOK_LANDING_PAGE_URL = "https://www.invono.se/handbok-bolagsstyrning";

export default function CredentialsCarouselCoffeeTableBook() {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-full select-none flex-col items-center gap-10 [&>p>strong]:text-background [&>p]:text-background/80 [&_h2]:text-xl [&_s]:opacity-40">
      <div className="flex flex-row-reverse gap-2">
        <div className="flex flex-col gap-2">
          <Badge
            className="self-start p-0 px-2 font-bold text-primary"
            variant="outline-primary"
          >
            {t("generic.new")}
          </Badge>
          <h2 className="flex-1 [&>strong]:text-brand">
            <Trans i18nKey={"coffee_table_book_promotion.heading"} />
          </h2>
        </div>
      </div>
      <div className="flex items-center justify-center gap-8">
        <div className="">
          <img
            className="max-h-[200px] drop-shadow-[0_5px_5px_rgba(255,255,255,0.25)]"
            src={bookImg}
          />
        </div>
        <div className="flex flex-1 flex-col gap-2">
          <span className="font-semibold">
            {t("coffee_table_book_promotion.description")}
          </span>
          <div>
            <strong>477 SEK </strong>
            <span className="text-sm">
              ({t("coffee_table_book_promotion.cost_info")})
            </span>
          </div>

          <Button
            variant="secondary"
            className="bg-transparent text-background hover:bg-background/20"
            onClick={() => {
              window.open(BOOK_LANDING_PAGE_URL, "_blank");
            }}
          >
            {t("generic.learn_more")}
          </Button>
        </div>
      </div>
      <Trans i18nKey="coffee_table_book_promotion.body" />
    </div>
  );
}
